// extracted by mini-css-extract-plugin
export default {"base":"EditModVersion_base__LcfCY","label":"EditModVersion_label__butXl","field":"EditModVersion_field__9QqZa"};